import { TextField, Toolbar, Typography } from '@mui/material';
import { useState } from 'react';

function PendingAgendaDataTableToolbar({ pageTitle, data2, setData, setHighlightQuery }) {

    const [searchText, setSearchText] = useState("");
    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.decision.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.agenda.toLocaleLowerCase().includes(text.toLocaleLowerCase())
            );

            setSearchText(text);
            setHighlightQuery(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };


    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', background: '#e1e1e1' }}>
            <div className="title">
                <Typography variant="title">{pageTitle}</Typography>
            </div>

            <div>

                {/* {
                    type === undefined ?
                        <Button variant="contained" sx={{ marginTop: '14px', marginRight: '10px' }} size="large" onClick={() => setAddAgendaDialogStatus(true)}>Ekle</Button> : null

                } */}


                <TextField
                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    label={"Arama Yap"}
                    className="mr-4"
                    // autoFocus
                    style={{ width: "400px", background: 'white' }}
                    placeholder={'Bilgi'}
                />
            </div>
            {/* 
            {
                type === undefined ?
                    <AddUpdateAgendaDialog open={addAgendaDialogStatus} onClose={() => setAddAgendaDialogStatus(false)} afterUpdateFunc={afterUpdateFunc} addAfterTable={addAfterTable} /> : null

            } */}


        </Toolbar>
    );
};

export default PendingAgendaDataTableToolbar